import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '@/api/api';
import { ENDPOINT } from '@/constants/endpoints';
import { UUID } from '@/types/common';
import {
  QuestionSchedulePeriod,
  QuestionScheduleResponse,
} from '@/types/management/managementSchedule';

type GetSchedulePayload = {
  period: QuestionSchedulePeriod;
};

type UpdateSchedulePayload = {
  questionId: UUID;
  date: string;
};

export const managementScheduleApi = createApi({
  reducerPath: 'managementScheduleApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['ManagementSchedule'],
  endpoints: builder => ({
    getManagementSchedule: builder.query<QuestionScheduleResponse, GetSchedulePayload>({
      query: params => ({
        url: ENDPOINT.MANAGEMENT.SCHEDULE.GET_ALL(),
        method: 'GET',
        params,
      }),
      providesTags: ['ManagementSchedule'],
    }),
    updateManagementSchedule: builder.mutation<void, UpdateSchedulePayload>({
      query: ({ questionId, date }) => ({
        url: ENDPOINT.MANAGEMENT.SCHEDULE.CHANGE_QUESTION(date),
        method: 'PUT',
        // API expects PascalCase key in request body.
        body: { QuestionId: questionId },
      }),
      invalidatesTags: ['ManagementSchedule'],
    }),
  }),
});

export const { useGetManagementScheduleQuery, useUpdateManagementScheduleMutation } =
  managementScheduleApi;
